export function startAd(ad, updatecb = () => {}) {
	const video = ad.element.querySelector('video');
	if (video) {
		video.currentTime = 0;
		video.play();
		if(typeof ad.volume !== 'undefined') {
			video.volume = ad.volume;
		}
	}
	// auto-Stop after x MS:
	ad.autoStopTimeOut = setTimeout(() => stopAd(ad, updatecb), ad.playTimeMs);
	const calcScaleByParent = () => {
		if (!ad || !ad.element) {
			return;
		}
		if (!ad.autoplay && !isElementInViewport(ad.element)) {
			return;
		}
		if (ad.autoplay && isElementInViewport(ad.element)) {
			ad.playing = true;
		}
		if(ad.origWidth) {
			ad.scale = parseInt(ad.element.getBoundingClientRect().width) / parseInt(ad.origWidth);
		} else if(ad.origHeight) {
			ad.scale = parseInt(ad.element.getBoundingClientRect().height) / parseInt(ad.origHeight);
		}
		ad.scale = Math.min(ad.maxScale || ad.scale, ad.scale);
		updatecb();
		requestAnimationFrame(calcScaleByParent);
	}
	// auto-Stop when leaving View:
	const autoStopIfLeavingView = () => {
		if (!ad.autoplay && !isElementInViewport(ad.element)) {
			stopAd(ad, updatecb);
			return;
		}
		requestAnimationFrame(autoStopIfLeavingView);
	}
	autoStopIfLeavingView();
	calcScaleByParent();
	ad.playing = true;
	updatecb();
}
const adStoppedEvent = new Event('adStopped');

export function stopAd(ad, updatecb = () => {}) {
	if(!ad.element) {
		return;
	}
	ad.playing = false;
	const video = ad.element.querySelector('video');
	clearTimeout(ad.autoStopTimeOut);
	if (video) {
		video.currentTime = ad.pauseImgOffsetS || ad.posterImgOffsetS || 0;
		video.pause();
		window.dispatchEvent(adStoppedEvent);
	}
	updatecb();
}

export function pauseAd(ad, updatecb = () => {}) {
	clearTimeout(ad.autoStopTimeOut);
	const video = ad.element.querySelector('video');
	if(video) {
		if(video.paused) {
			ad.autoStopTimeOut = setTimeout(() => stopAd(ad, updatecb), ad.playTimeMs - video.currentTime);
			video.play();
		} else {
			video.pause();
		}
		window.dispatchEvent(adStoppedEvent);
		updatecb();
	}
}

/**
 * there's a Bug in Chrome which stops transitioning scaling in an overflow:hidden parent
 * see e.g. https://stackoverflow.com/questions/16687023/bug-with-transform-scale-and-overflow-hidden-in-chrome
 *
 * it's also impossible to delay the transition of overflow
 * therefore we need to handle it with JS
 */
export function scaleAdOnHover(node, ad = {}) {
	let mouseIsOver = false;
	let greyOverlay;
	
	function addGreyOverlay() {
		if (node.parentElement && !node.parentElement.querySelector('.greyOverlay')) {
			greyOverlay = document.createElement('div');
			greyOverlay.classList.add('greyOverlay');
			node.insertAdjacentElement('beforeend', greyOverlay);
		}
		greyOverlay.style.backgroundColor = 'rgba(0, 0, 0, .5)';
		
		const imageOrVideoRect = imgOrVideo.getBoundingClientRect();
		const parentRect = imgOrVideo.parentElement?.getBoundingClientRect();
		if(parentRect) {
			greyOverlay.style.width = Math.min(imageOrVideoRect.width, parentRect.width) + 'px';
			greyOverlay.style.height = Math.min(imageOrVideoRect.height, parentRect.height) + 'px';
		}
	}
	
	function reset() {
		if (ad.playing) {
			return;
		}
		mouseIsOver = false;
	}
	
	function mouseOverEffect() {
		mouseIsOver = true;
	}
	
	const imgOrVideo = node.querySelector('.posterImg') || node.querySelector('img, video');
	let origMaxSize = parseInt(Math.min(imgOrVideo.clientWidth, imgOrVideo.clientHeight));
	
	function animate() {
		if (!node || !imgOrVideo) {
			requestAnimationFrame(animate);
			return;
		}
		// recalculating due to e.g. browser-resize:
		origMaxSize = parseInt(Math.min(imgOrVideo.clientWidth, imgOrVideo.clientHeight));
		if (mouseIsOver) {
			imgOrVideo.style.transform = 'scale(1)';
			greyOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0)';
			// this fixes the Chrome-Bug:
			setTimeout(() => {
				if (mouseIsOver) {
					node.style.overflow = 'unset';
				}
			}, 200);
		}
		else {
			addGreyOverlay();
			const scale = (origMaxSize + 5) / origMaxSize;
			// the scale here could be too much, therefore we use the maxScale calculated earlier:
			const maxScale = getComputedStyle(imgOrVideo).getPropertyValue('--maxScale');
			imgOrVideo.style.transform = `scale(${maxScale || scale})`;
			imgOrVideo.style.transformOrigin = '50% 25%';
			imgOrVideo.style.transition = 'transform .2s';
			node.style.overflow = 'hidden';
		}
	}
	
	animate();
	
	document.addEventListener('scroll', animate, true);
	window.addEventListener('animatedPagesDone', addGreyOverlay, true);
	window.addEventListener('imagesLoaded', addGreyOverlay, true);
	window.addEventListener('adStopped', addGreyOverlay, true);
	document.addEventListener('mousemove', animate, true);
	
	node.addEventListener('mouseover', mouseOverEffect, true);
	node.addEventListener('mouseleave', reset, true);
	if (node.classList.contains('container-overlay')) {
		node.parentElement.addEventListener('mouseover', mouseOverEffect, true);
		node.parentElement.addEventListener('mouseleave', reset, true);
	}
	reset();
	
	return {
		destroy() {
			node.removeEventListener('mouseover', mouseOverEffect, true);
			node.removeEventListener('mouseleave', reset, true);
			if (node.classList.contains('container-overlay') && node.parentElement) {
				node.parentElement.removeEventListener('mouseover', mouseOverEffect, true);
				node.parentElement.removeEventListener('mouseleave', reset, true);
			}
		}
	}
}

export function isElementInViewport(element) {
	const iframe = element.querySelector('iframe');
	let prevElement = iframe ? iframe.previousElementSibling : false;
	if (iframe && prevElement && prevElement.tagName.toLowerCase() === 'img') {
		if (!iframe.getAttribute('startWidth')) {
			iframe.setAttribute('startWidth', iframe.getBoundingClientRect().width);
		}
		iframe.style.scale = prevElement.getBoundingClientRect().width / iframe.getAttribute('startWidth');
		iframe.style.width = prevElement.getBoundingClientRect().width + 'px';
		iframe.style.height = prevElement.getBoundingClientRect().height + 'px';
		const iframeBanner = iframe.contentDocument?.body?.querySelector('#banner');
		if(iframeBanner) {
			iframeBanner.style.width = '100%';
			iframeBanner.style.height = '100%';
		}
	}
	const rect = element.getBoundingClientRect();
	const windowHeight = window.innerHeight || document.documentElement.clientHeight;
	return rect.bottom > 0 && rect.top < windowHeight;
}
